import type { BenefitModalProps } from '../../../../../@types/benefitModalProps';
import { AragModal } from '../aragModal/AragModal';
import RechtsberatungJpg from './images/rent_legal.jpeg';
import RechtsberatungWebp from './images/rent_legal.webp';
import RechtsberatungMobileJpg from './images/rent_legal_mobile.jpeg';
import RechtsberatungMobileWebp from './images/rent_legal_mobile.webp';
import PhonePng from './images/phone.png';
import PhoneWebp from './images/phone.webp';
import Section3Png from './images/section3.png';
import Section3Webp from './images/section3.webp';
import { InsuranceServiceName } from '@/@types/insurance';

export const Rechtsberatung = ({ isVisible, onClose }: BenefitModalProps) => {
  return (
    <AragModal
      serviceName={InsuranceServiceName.RECHTSBERATUNG}
      image={RechtsberatungJpg}
      imageWebp={RechtsberatungWebp}
      imageMobile={RechtsberatungMobileJpg}
      imageMobileWebp={RechtsberatungMobileWebp}
      howItWorksImage1Png={PhonePng}
      howItWorksImage1WebP={PhoneWebp}
      howItWorksImage2Png={Section3Png}
      howItWorksImage2WebP={Section3Webp}
      isVisible={isVisible}
      onClose={onClose}
    />
  );
};

export default Rechtsberatung;
